export const DOWN_ICON = (
  <path
    // fill-rule="evenodd"
    // clip-rule="evenodd"
    d="M2.36612 7.35798C2.85427 6.88067 3.64573 6.88067 4.13388 7.35798L12 15.0493L19.8661 7.35798C20.3543 6.88067 21.1457 6.88067 21.6339 7.35798C22.122 7.83529 22.122 8.60916 21.6339 9.08646L12.8839 17.642C12.3957 18.1193 11.6043 18.1193 11.1161 17.642L2.36612 9.08646C1.87796 8.60916 1.87796 7.83529 2.36612 7.35798Z"
  />
)
